module.exports = __webpack_public_path__ + "static/media/social-twitter.d8eabfb5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/auth/social-twitter.svg
// module id = 164
// module chunks = 0